export default class ConsoleService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new ConsoleService());
	}

	setConsole(console) {
		this.console = console;
	}

	getUsers() {
		return this.console.getUsers();
	}

	getRoles() {
		return this.console.getRoles();
	}

	isAdmin() {
		return this.console.isAdmin();
	}

	currentUser() {
		return this.console.user;
	}

	refreshToken() {
		return this.console.refreshToken();
	}

	getTokenDetails() {
		return this.console.getTokenDetails();
	}

}
